import { Component, inject, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { MaintenanceRoutineModel } from 'src/app/models/maintenance/maintenance-routine.model';
import { MaintenanceRoutineService } from 'src/app/services/maintenance/maintenance-routine.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-copy-maintenance-routine',
  templateUrl: './copy-maintenance-routine.component.html',
  styleUrls: ['./copy-maintenance-routine.component.scss'],
  standalone: false
})
export class CopyMaintenanceRoutineComponent implements OnInit {
  public config = inject(DynamicDialogConfig);
  private readonly maintenanceRoutineService = inject(MaintenanceRoutineService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  @Optional() private ref = inject(DynamicDialogRef);

  listMaintenanceRoutines: any[] = [];
  maintenanceRoutineModel: MaintenanceRoutineModel = new MaintenanceRoutineModel();
  maintenanceRoutineOrigin: number = 0;
  suscription: Subscription;

  ngOnInit() {
    this.getAllMaintenanceRoutinesForSelect();

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.maintenanceRoutineModel = inputs.maintenanceRoutineModel;
    });

  }

  async changeMaintenanceRoutine(maintenanceRoutineId: number) {
    this.maintenanceRoutineOrigin = maintenanceRoutineId;
  }

  async copyMaintenanceRoutine() {
    if (this.maintenanceRoutineOrigin == 0) {
      this.toastHandlerService.showToast('warning', 'Debe seleccionar un equipo valido.', 'Atención');
      return;
    } else if (this.maintenanceRoutineOrigin == this.maintenanceRoutineModel.maintenanceRoutineId) {
      this.toastHandlerService.showToast('warning', 'No es posible copiar información de la misma rutina de mantenimiento.', 'Atención');
      return;
    }

    try {
      const response = await firstValueFrom(this.maintenanceRoutineService.copyMaintenanceRoutineAsync(this.maintenanceRoutineOrigin, this.maintenanceRoutineModel.maintenanceRoutineId));
      if (response) {
        const output$ = this.config.data?.output$;
        output$?.next({ type: 'updateRegister', payload: true });
        this.toastHandlerService.showToast('success', 'La rutina se copio exitosamente.', '');
      }
      this.maintenanceRoutineOrigin = 0;
      if (this.ref) this.ref.close();
    } catch (error) {
      console.error('Error al copiar la rutina de mantenimiento.', error);
    }
  }


  async getAllMaintenanceRoutinesForSelect() {
    this.listMaintenanceRoutines = await firstValueFrom(this.maintenanceRoutineService.getAllMaintenanceRoutinesForSelect());
  }
}
